import { b as _typeof } from './client-19c3a323.esm.js';
import { u as useInternalQuery, _ as _asyncToGenerator, a as _regeneratorRuntime, b as _objectSpread2, c as usePickQueryKeys } from './useInternalQuery-8432b378.esm.js';
import { watchLivepeerProvider, getLivepeerProvider, getAsset, createAsset, getPlaybackInfo } from 'livepeer/actions';
import { createClient } from 'livepeer/client';
import { pick } from 'livepeer/utils';
import { p as prefetchQuery, u as useInternalMutation } from './useInternalMutation-c43b2d2f.esm.js';
import { useState, useMemo } from 'react';
import { useSyncExternalStoreWithSelector } from 'use-sync-external-store/shim/with-selector.js';

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function useLivepeerProvider() {
  return useSyncExternalStoreWithSelector(function (cb) {
    return watchLivepeerProvider(cb);
  }, function () {
    return getLivepeerProvider();
  }, function () {
    return getLivepeerProvider();
  }, function (x) {
    return x;
  });
}

var queryKey$1 = function queryKey(args, config) {
  return [{
    entity: 'getAsset',
    args: args,
    config: config
  }];
};
function useAsset(args) {
  var livepeerProvider = useLivepeerProvider();
  return useInternalQuery(getQueryParams$1(args, livepeerProvider));
}
function prefetchAsset(_x, _x2) {
  return _prefetchAsset.apply(this, arguments);
}
function _prefetchAsset() {
  _prefetchAsset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(args, config) {
    var livepeerClient;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            livepeerClient = createClient(config);
            return _context2.abrupt("return", prefetchQuery(getQueryParams$1(args, livepeerClient.provider)));
          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _prefetchAsset.apply(this, arguments);
}
function getQueryParams$1(args, provider) {
  var _args$assetId;
  var getAssetArgs = typeof args === 'string' ? args : {
    assetId: (_args$assetId = args === null || args === void 0 ? void 0 : args.assetId) !== null && _args$assetId !== void 0 ? _args$assetId : ''
  };
  return _objectSpread2({
    clearClient: args.clearClient,
    queryKey: queryKey$1(getAssetArgs, provider.getConfig()),
    queryFn: function () {
      var _queryFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", getAsset(getAssetArgs));
              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      function queryFn() {
        return _queryFn.apply(this, arguments);
      }
      return queryFn;
    }(),
    enabled: Boolean(typeof args === 'string' ? args : args === null || args === void 0 ? void 0 : args.assetId)
  }, _typeof(args) === 'object' ? pick(args, usePickQueryKeys) : {});
}

function useCreateAsset(options) {
  var livepeerProvider = useLivepeerProvider();
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    progress = _useState2[0],
    setProgress = _useState2[1];
  var internalQuery = useInternalMutation(options, /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(args) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", createAsset(_objectSpread2(_objectSpread2({}, args), {}, {
                onProgress: function onProgress(progress) {
                  return setProgress(progress);
                }
              })));
            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [{
    entity: 'createAsset',
    livepeerProvider: livepeerProvider
  }]);
  return useMemo(function () {
    return _objectSpread2(_objectSpread2({}, internalQuery), {}, {
      progress: progress
    });
  }, [internalQuery, progress]);
}

var queryKey = function queryKey(args, config) {
  return [{
    entity: 'getPlaybackInfo',
    args: args,
    config: config
  }];
};
function usePlaybackInfo(args) {
  var livepeerProvider = useLivepeerProvider();
  return useInternalQuery(getQueryParams(args, livepeerProvider));
}
function prefetchPlaybackInfo(_x, _x2) {
  return _prefetchPlaybackInfo.apply(this, arguments);
}
function _prefetchPlaybackInfo() {
  _prefetchPlaybackInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(args, config) {
    var livepeerClient;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            livepeerClient = createClient(config);
            return _context2.abrupt("return", prefetchQuery(getQueryParams(args, livepeerClient.provider)));
          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _prefetchPlaybackInfo.apply(this, arguments);
}
function getQueryParams(args, provider) {
  var _args$playbackId;
  var getPlaybackInfoArgs = typeof args === 'string' ? args : {
    playbackId: (_args$playbackId = args === null || args === void 0 ? void 0 : args.playbackId) !== null && _args$playbackId !== void 0 ? _args$playbackId : ''
  };
  return _objectSpread2({
    clearClient: args.clearClient,
    queryKey: queryKey(getPlaybackInfoArgs, provider.getConfig()),
    queryFn: function () {
      var _queryFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", getPlaybackInfo(args));
              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      function queryFn() {
        return _queryFn.apply(this, arguments);
      }
      return queryFn;
    }(),
    enabled: Boolean(typeof args === 'string' ? args : args === null || args === void 0 ? void 0 : args.playbackId)
  }, _typeof(args) === 'object' ? pick(args, usePickQueryKeys) : {});
}

export { _slicedToArray as _, prefetchPlaybackInfo as a, useCreateAsset as b, useLivepeerProvider as c, usePlaybackInfo as d, prefetchAsset as p, useAsset as u };
